import {useCurrencyFormatter as useCurrencyFormatterFactory} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../components/thankYouPage/Widget/ControllerContext';

export function useCurrencyFormatter() {
  const format = useCurrencyFormatterFactory();
  const {currency} = useControllerProps().thankYouPageStore;

  return (value: string | number) => format({value, currency});
}
